import { createSelector } from '@ngrx/store';
import { onboardingFeature } from './onboarding.reducer';

export const selectValidResidences = createSelector(onboardingFeature.selectCountries, (countries) => {
  return countries.filter((country) => country.isResidencyAllowed);
});

export const selectValidTaxResidences = createSelector(onboardingFeature.selectCountries, (countries) => {
  return countries.filter((country) => country.isTaxAllowed);
});
